import React from 'react';

import BLOCK_RIZ_CONFIG from 'shared-constants/src/blockRizConfig';
import { getItem } from '../localStorage';
import blockRizLogic from '../blockRizLogic';
import trackGTMEvents from '../trackGTMEvents/new';
import trackTLEvents from '../trackTLEvents';

import openGenericAfterSpecificModal from './openGenericAfterSpecificModal';
import openFeedbackModal from './openFeedbackModal';
import openProposeSaveSearchModal from '../saveSearch/openProposeSaveSearchModal';
import { proposeValidByTimestamp } from '../helpersMyCasa/proposeSaveSearchAfterLead';

const createModalTitle = (h1, infosDisplayValues) => `per ${h1.replace('in Vendita', '').replace('in Affitto', '')}${infosDisplayValues?.size ? ` | ${infosDisplayValues?.size}m²` : ''}${infosDisplayValues?.price && !infosDisplayValues?.isPrivateNegotiation ? ` | ${infosDisplayValues?.price}` : ''}`;

export const sendSpecificLeadCallBack = async ({
  response,
  userData,
  modalTitle,
  closeModal,
  openModalAction,
  closeModalAction,
  createProposeSaveSearchModal,
  createNewSaveSearchModal,
  createGenericAfterSpecificModal,
  createFeedbackModal,
  createNewSaveSearchFeedbackModal,
  setUserFormDataAction,
  trackPosition = null,
  eventFromConf = null,
  teaEvPage = null,
  leadConf,
  proposeBkm,
  proposeSaveSearchData,
  disableHistoryBackOnClose = false,
}) => {
  const {
    isMobile,
    device,
    listingId,
    partnerId,
    channel,
    category,
    propertyTypeGroup = 'case',
    rizLocation,
    publisher: {
      publisherId,
      publisherName,
      publisherSlug,
      publisherParent,
      publisherType,
      isAgentPro,
    },
    isProjectProfile,
    isProjectProfileUnit,
    proposeGeneric,
    filters,
    locations = null,
    app,
    isPublisherLead,
    sendLeadCallback = null,
    isPublisherPage,
    idlPropertyType,
  } = leadConf;

  const success = response.data && response.data.code === 201;
  const cEmail = response?.data?.data?.cEmail || null;
  success && sendLeadCallback && sendLeadCallback();

  const correctPublisherName = isAgentPro && publisherParent
    ? publisherParent.name
    : publisherName;

  const evMore = {};

  // update user formData
  if (setUserFormDataAction) {
    const formDataObj = {
      consent: userData.consent,
      email: userData.email,
      firstName: userData.firstName,
      lastName: '',
      telephone: userData.telephone || '',
    };
    if (!userData.isAuthenticated && cEmail) {
      formDataObj.cEmail = cEmail;
      evMore.user = {
        hash: cEmail,
        status: 2,
        type: 1,
      };
    }
    await setUserFormDataAction(formDataObj);
  }

  await closeModalAction({ close: closeModal });

  setTimeout(() => {
    let productType = 'property';
    if (isPublisherLead) {
      productType = 'agency';
    } else if (isProjectProfile && !isProjectProfileUnit) {
      productType = 'newDevelopment';
    }

    evMore.contact = {
      channel: 'email',
      productType,
      errorField: ['', '', ''],
    };

    if (app === 'P18') {
      if (listingId) {
        evMore.ad = {
          id: listingId,
        };
        if (partnerId) {
          evMore.ad.idId = partnerId;
        }
      }

      if (!isPublisherPage && publisherSlug) {
        evMore.agency = {
          name: [publisherSlug],
        };
      }

      if (idlPropertyType) {
        evMore.typology = idlPropertyType;
      }
    }

    if (success) {
      evMore.contact.outcome = 'ok';

      // INVIO SPECIFICA AVVENUTO
      if (isPublisherLead) {
        const pubLeadEvt = {
          category: 'Lead',
          action: 'SendEmail',
          label: `Agency - ${publisherId.toString()}`,
        };
        if (trackPosition) {
          pubLeadEvt.position = trackPosition;
        }
        trackGTMEvents(pubLeadEvt, {}, true);
        trackTLEvents({
          evObj: {
            event: {
              type: 'view',
              name: 'contact',
              origin: '',
            },
          },
          evMore,
          evPage: teaEvPage || {},
        });

        openFeedbackModal({
          openModalAction,
          createFeedbackModal,
          disableHistoryBackOnClose,
          isMobile,
          fail: false,
          failMethod: null,
          feedback: (
            <>
              <p className="rizmdl__txt tp-s--l tp-w--m c-txt--f0 tp-a--c mb--m">
                Grazie!
              </p>
              <p className="rizmdl__txt tp-s--m tp-w--s c-txt--secondary tp-a--c">
                Richiesta inviata con successo
              </p>
            </>
          ),
          title: modalTitle,
        });
      } else {
        // Tracciamento invio specifica
        const successEvent = {
          category: 'Lead',
          action: 'SendEmail',
          label: listingId.toString(),
        };

        if (trackPosition) {
          successEvent.position = trackPosition;
        }
        if (
          eventFromConf
          && (eventFromConf.eventsList || []).includes(successEvent.action)
          && eventFromConf.value
        ) {
          successEvent.from = eventFromConf.value;
        }

        trackGTMEvents(successEvent, {}, true);
        trackTLEvents({
          evObj: {
            event: {
              type: 'view',
              name: 'contact',
              origin: '',
            },
          },
          evMore,
          evPage: teaEvPage || {},
        });

        // logica blocco riz

        const rizStorageArray = getItem('csa_riz_to_block') || [];
        const rizData = {
          email: userData.email,
          channel,
          category,
          propertyTypeGroup,
          locationCode: rizLocation,
        };

        const { shouldRizBeBlocked } = blockRizLogic(
          rizStorageArray,
          rizData,
          BLOCK_RIZ_CONFIG,
        );

        if (
          isProjectProfile
          || isProjectProfileUnit
          || !proposeGeneric
          || shouldRizBeBlocked
        ) {
          // riz bloccata, mostriamo la success
          const proposeGenericEvt = {
            category: 'GenericLead',
            action: 'ProposeGeneric',
            label: shouldRizBeBlocked ? 'No-Filtered' : 'No-NotApplicable',
          };
          if (trackPosition) {
            proposeGenericEvt.position = trackPosition;
          }
          trackGTMEvents(proposeGenericEvt, {}, true);

          const { propose, reason } = proposeValidByTimestamp(proposeBkm);

          if (propose) {
            const {
              searchData: {
                saveSearchProps: {
                  propose: {
                    from,
                    searchType,
                  },
                },
              },
            } = proposeSaveSearchData;

            trackGTMEvents({
              category: 'FavouriteAndAlert',
              action: 'ProposeSaveSearch',
              label: `Yes-${searchType}`,
              from,
            }, {}, true);

            openProposeSaveSearchModal({
              openModalAction,
              closeModalAction,
              createProposeSaveSearchModal,
              createNewSaveSearchModal,
              createGenericAfterSpecificModal,
              createNewSaveSearchFeedbackModal,
              createFeedbackModal,
              proposeSaveSearchData: {
                ...proposeSaveSearchData,
                publisher: {
                  publisherName,
                  publisherType,
                  isAgentPro,
                },
                doNotProposeGeneric: true,
              },
              disableHistoryBackOnClose,
            });
          } else {
            trackGTMEvents({
              category: 'FavouriteAndAlert',
              action: 'ProposeSaveSearch',
              label: reason,
              from: 'SendEmail',
            }, {}, true);

            openFeedbackModal({
              openModalAction,
              createFeedbackModal,
              isMobile,
              fail: false,
              failMethod: null,
              feedback: (
                <>
                  <p className="rizmdl__txt tp-s--l tp-w--m c-txt--f0 tp-a--c mb--m">
                    Grazie!
                  </p>
                  <p className="rizmdl__txt tp-s--m tp-w--s c-txt--secondary tp-a--c">
                    Richiesta inviata con successo
                  </p>
                </>
              ),
              title: modalTitle,
              disableHistoryBackOnClose,
            });
          }
        } else {
          // mostriamo la generica
          const proposeGenericEvt = {
            category: 'GenericLead',
            action: 'ProposeGeneric',
            label: 'Yes',
          };
          if (trackPosition) {
            proposeGenericEvt.position = trackPosition;
          }
          trackGTMEvents(proposeGenericEvt, {}, true);

          trackGTMEvents({
            category: 'FavouriteAndAlert',
            action: 'ProposeSaveSearch',
            label: 'No-ProposeGeneric',
            from: 'SendEmail',
          }, {}, true);

          openGenericAfterSpecificModal({
            openModalAction,
            createGenericAfterSpecificModal,
            createFeedbackModal,
            closeModalAction,
            title: modalTitle,
            listingId,
            channel,
            category,
            propertyTypeGroup,
            filters,
            publisherName: correctPublisherName,
            device,
            rizLocation,
            userData,
            locations,
            app,
            isMobile,
            disableHistoryBackOnClose,
          });
        }
      }
    } else {
      // INVIO SPECIFICA FALLITO
      evMore.contact.outcome = 'error';

      trackTLEvents({
        evObj: {
          event: {
            type: 'view',
            name: 'contact',
            origin: '',
          },
        },
        evMore,
        evPage: teaEvPage || {},
      });

      // mostriamo la failure
      openFeedbackModal({
        openModalAction,
        createFeedbackModal,
        isMobile,
        fail: true,
        failMethod: null,
        feedback: (
          <p className="rizmdl__txt--err tp-s--l tp-w--m c-txt--f0 tp-a--c mb--m">
            Oops... qualcosa è andato storto!
            <br />
            Invia di nuovo la richiesta.
          </p>
        ),
        title: modalTitle,
        disableHistoryBackOnClose,
      });
    }
  }, 501);
};

export default ({
  openModalAction,
  closeModalAction,
  createSpecificModal,
  createProposeSaveSearchModal,
  createLoginModal,
  getUser,
  getUserLoginPayload,
  showSynchingDialog,
  createNewSaveSearchModal,
  createGenericAfterSpecificModal,
  createFeedbackModal,
  createNewSaveSearchFeedbackModal,
  setUserFormDataAction = null,
  disableHistoryBackOnClose = false,
  leadConf,
  proposeBkm,
  proposeSaveSearchData,
  siteUrl,
}) => {
  const {
    isMobile,
    device,
    listingId,
    propertyTypeGroup = 'case',
    propertyType = '',
    hasNoMedia = false,
    infosDisplayValues,
    h1,
    publisher,
    refPublisher,
    isProjectProfile,
    user,
    wantVirtualTour = false,
    justEmail = false,
    app,
    isPublisherLead,
    startCall = null,
    isDisabled = false,
    disabledTxtAreaProps = {},
    eventFromConf = null,
    teaEvPage = null,
  } = leadConf;
  openModalAction(createSpecificModal({
    isMobile,
    device,
    disableHistoryBackOnClose,
    publisher,
    siteUrl,
    listing: isPublisherLead
      ? {}
      : {
        id: listingId,
        title: createModalTitle(h1, infosDisplayValues),
        refPublisher,
        propertyTypeGroup,
        propertyType,
        hasNoMedia,
        isProjectProfile,
      },
    user,
    wantVirtualTour,
    justEmail,
    startCall,
    isPublisherLead,
    isDisabled,
    disabledTxtAreaProps,
    app,
    sendSpecificLeadCallBack,
    sendSpecificLeadCallBackPayload: {
      openModalAction,
      closeModalAction,
      createSpecificModal,
      createProposeSaveSearchModal,
      createLoginModal,
      getUser,
      getUserLoginPayload,
      showSynchingDialog,
      createNewSaveSearchModal,
      createGenericAfterSpecificModal,
      createNewSaveSearchFeedbackModal,
      createFeedbackModal,
      setUserFormDataAction,
      leadConf,
      proposeBkm,
      proposeSaveSearchData,
      eventFromConf,
      teaEvPage,
      disableHistoryBackOnClose,
    },
  }));
};
